import type { CSSProperties } from "react";
import "./Skeleton.css";

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  circle?: boolean;
  className?: string;
}

export function Skeleton({ width = "100%", height = 14, radius, circle = false, className }: SkeletonProps) {
  const style: CSSProperties = {
    width,
    height,
    borderRadius: circle ? "50%" : (radius ?? "var(--r-xs)"),
  };

  return <span className={["ui-skeleton", className ?? ""].filter(Boolean).join(" ")} style={style} aria-hidden="true" />;
}

export interface SkeletonTextProps {
  lines?: number;
  className?: string;
}

export function SkeletonText({ lines = 3, className }: SkeletonTextProps) {
  return (
    <span className={["ui-skeleton-text", className ?? ""].filter(Boolean).join(" ")} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          height={12}
          // Last line runs shorter so a text block doesn't look like a
          // uniform grey rectangle — mirrors how prose actually wraps.
          width={i === lines - 1 ? "60%" : "100%"}
        />
      ))}
    </span>
  );
}
